import React, { useState } from 'react';
import tab1 from '../assets/tab1.png';
import tab2 from '../assets/tab2.png';

const InteractiveTab = () => {
  const [activeTab, setActiveTab] = useState('Quick Win Sprint');
  const isMobile = window.innerWidth < 768;

  return (
    <div
      className="w-full rounded-t-3xl overflow-hidden relative"
      style={{
        background: activeTab === 'Quick Win Sprint'
          ? 'rgba(111, 67, 254, 1)'
          : '#EAF727',
        minHeight: isMobile ? 'auto' : '690px'
      }}
    >
      <div className="p-4 sm:p-6 md:p-8 lg:p-10 xl:p-12">
        <div className="flex flex-col md:flex-row md:items-start gap-6 md:gap-8 lg:gap-10 xl:gap-12 relative">
          {/* Tabs */}
          <div className="bg-white rounded-lg p-1 md:p-2 inline-flex mb-6 md:mb-8 lg:mb-10 w-full md:w-auto">
            <button
              className="px-3 py-2 md:px-4 md:py-3 lg:px-6 lg:py-4 rounded-lg transition-all duration-300 text-xs sm:text-sm md:text-base lg:text-lg font-bold flex-1 md:flex-none"
              style={{
                backgroundColor: activeTab === 'Quick Win Sprint' ? '#EAF727' : 'transparent',
                color: '#000000',
                fontFamily: 'Space Grotesk',
                letterSpacing: '-2%'
              }}
              onClick={() => setActiveTab('Quick Win Sprint')}
            >
              Quick Win Sprint
            </button>

            <button
              className="px-3 py-2 md:px-4 md:py-3 lg:px-6 lg:py-4 rounded-lg transition-all duration-300 text-xs sm:text-sm md:text-base lg:text-lg font-bold flex-1 md:flex-none"
              style={{
                backgroundColor: activeTab === 'Design Partner Plan' ? '#6F43FE' : 'transparent',
                color: activeTab === 'Design Partner Plan' ? '#FFFFFF' : '#000000',
                fontFamily: 'Space Grotesk',
                letterSpacing: '-2%'
              }}
              onClick={() => setActiveTab('Design Partner Plan')}
            >
              Design Partner Plan
            </button>
          </div>

          {/* Image */}
          <div className="md:absolute md:right-0 md:top-4 md:w-1/2 md:pr-8 md:pt-2 md:translate-x-4">
            <div className="rounded-t-3xl overflow-hidden w-full">
              <img
                src={activeTab === 'Quick Win Sprint' ? tab1 : tab2}
                alt={activeTab}
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="md:w-1/2 space-y-4 md:space-y-8 flex flex-col justify-start mt-8 md:mt-16 break-words">
          <h2
            className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl leading-tight"
            style={{
              fontFamily: 'Bricolage Grotesque',
              fontWeight: '500',
              letterSpacing: '-2%',
              color: activeTab === 'Quick Win Sprint' ? '#FFFFFF' : '#000000',
              maxWidth: '100%', // ensures no overflow
              wordBreak: 'break-word',
            }}
          >
            {activeTab === 'Quick Win Sprint'
              ? "Let's fix your confusing website "
              : "Marketing Assets waiting on design?"}
          </h2>

          <p
            className="text-base md:text-lg lg:text-xl xl:text-2xl leading-relaxed"
            style={{
              fontFamily: 'Space Grotesk',
              fontWeight: '400',
              letterSpacing: '-2%',
              color: activeTab === 'Quick Win Sprint' ? 'rgba(255, 255, 255, 0.8)' : '#000000',
              maxWidth: '90%',
              wordBreak: 'break-word',
            }}
          >
            {activeTab === 'Quick Win Sprint'
              ? "We sharpen your story, build trust, and design a website that turns visitors into customers"
              : "Get all your design tasks done with one monthly subscription. Unlimited creatives, delivered weekly"}
          </p>

          <button
  className="bg-black text-white rounded-lg px-4 py-3 md:px-5 md:py-4 lg:px-6 lg:py-5 text-base md:text-lg lg:text-xl font-bold capitalize transition-transform hover:scale-105 w-full md:w-auto mt-4"
  style={{
    fontFamily: 'Space Grotesk',
    letterSpacing: '0%',
    maxWidth: '420px',
    whiteSpace: 'normal'
  }}
  onClick={() =>
    window.open(
      activeTab === 'Quick Win Sprint'
        ? 'https://cal.com/payandesign/quickwinsprint'
        : 'https://cal.com/payandesign/designpartner',
      '_blank',
      'noopener,noreferrer'
    )
  }
>
  {activeTab === 'Quick Win Sprint' ? 'See What We Fix' : 'Fix Your Backlog Now'}
</button>


          {/* <p
            className="text-sm md:text-base lg:text-lg xl:text-xl mt-4"
            style={{
              fontFamily: 'Space Grotesk',
              fontWeight: '400',
              letterSpacing: '-2%',
              color: activeTab === 'Quick Win Sprint' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)',
              maxWidth: '100%',
              wordBreak: 'break-word',
            }}
          >
            AI startup increases +60% sign-ups in 3 weeks →
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default InteractiveTab;
